import { useState } from "react";
import {
  FileText,
  Home,
  GraduationCap,
  AlertTriangle,
  CheckCircle,
  Clock,
  DollarSign,
  BookOpen,
  Download,
  Phone,
  
} from "lucide-react";
import GdFree from "../../GdFree";
import RegistProcedure from "./RegistProcedure";
import StudentHousing from "../../accommodation/StudentHousing";
import RecentUploads from "../../../../components/supportPdf/RecentUploads";

// Composant Badge
const Badge = ({ children, variant = "default", className = "" }) => {
  const baseClasses =
    "inline-flex   items-center px-2 py-2 rounded text-xs font-medium";
  const variants = {
    default: "bg-blue-100 dark:bg-gray-700 dark:text-gray-200 text-blue-800",
    secondary: "bg-gray-100 dark:bg-gray-700 dark:text-gray-200 text-gray-800",
    success:
      "bg-green-100 border-blue-800  border  dark:bg-gray-700 dark:text-gray-200 text-green-800",
    warning:
      "bg-yellow-100 border-red-600  border dark:bg-gray-700 dark:text-gray-200 text-yellow-800",
    danger: "bg-gray-200 dark:bg-gray-700 dark:text-gray-200 text-red-800",
  };

  return (
    <span className={`${baseClasses} ${variants[variant]} ${className}`}>
      {children}
    </span>
  );
};

// Composant Card
const Card = ({ children, className = "" }) => {
  return (
    <div
      className={`bg-white rounded-lg border border-gray-200 shadow-sm ${className}`}
    >
      {children}
    </div>
  );
};

// const CardHeader = ({ children }) => {
//   return <div className="p-6 pb-4">{children}</div>;
// };

// const CardContent = ({ children }) => {
//   return <div className="px-6 pb-6">{children}</div>;
// };

// const CardTitle = ({ children, className = "" }) => {
//   return (
//     <h3
//       className={`text-lg font-semibold leading-none tracking-tight ${className}`}
//     >
//       {children}
//     </h3>
//   );
// };

// Composant Button
// const Button = ({
//   children,
//   variant = "default",
//   className = "",
//   onClick,
//   ...props
// }) => {
//   const baseClasses =
//     "inline-flex items-center justify-center rounded-md text-sm font-medium transition-colors focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 disabled:opacity-50 disabled:pointer-events-none";
//   const variants = {
//     default: "bg-blue-600 text-white hover:bg-blue-700 h-10 px-4 py-2",
//     outline: "border border-gray-300 bg-white hover:bg-gray-50 h-10 px-4 py-2",
//     success: "bg-green-600 text-white hover:bg-green-700 h-10 px-4 py-2",
//   };

//   return (
//     <button
//       className={`${baseClasses} ${variants[variant]} ${className}`}
//       onClick={onClick}
//       {...props}
//     >
//       {children}
//     </button>
//   );
// };

// INFO SUPPLEMENTAIRE
const infoSupLoge = [
  {
    title: "Des infrastructures de qualité ",
    description: "Routes éclairées, commerces, centres médicaux ",
  },
  {
    title: "Un accès rapide aux universités ",
    description:
      "La majorité des résidences sont situées à moins de 7 a 10km des grands établissements d'enseignement ",
  },
  {
    title: "Des moyens de transport efficaces  ",
    description:
      "Bus, matatus, ou services comme Bolt et Uber, souvent accessibles en moins de 5 minutes ",
  },
  {
    title: "Un environnement actif",
    description:
      "Restaurants, cafés, bibliothèques espaces de coworking et v. installations sportives sont à proximité. ",
  },
];

function RgByNord() {
  const [activeSection, setActiveSection] = useState("visa");

  const visaDocuments = [
    {
      name: "Passeport valide",
      description:
        "- Assurez-vous qu'il soit à jour et valide pour toute la durée de vos études",
      required: true,
      processing: "Immédiat",
    },
    {
      name: "Une lettre d'autorisation ",
      description: "-	Si vous êtes mineur et que vous faite cette expérience",
      description2: "- La durée dépend du système régional. ",
      required: true,
      processing: "2-3 jours",
    },
    {
      name: "	Une lettre d'admission émise par un établissement d'enseignement reconnu",
      description:
        "- Si vous n'en avez pas encore, nous pouvons vous en fournir une grâce à nos partenaires éducatifs avec lesquels nous collaborons. ",
      required: false,
      processing: "1-2 jours",
    },
    {
      name: " 	Visa étudiant ",
      description:
        "- La demande et le renouvellement de votre visa étudiant seront effectué une fois arrivée au Kenya. Vous serez accompagnée dans cette demarche si vous le souhaitez ",
      required: false,
      processing: "2-4 mois",
    },
  ];

  // HOUSINGOPTIONS MODELS
  const housingOptions = [
    {
      description: "chambres : simples, doubles, quadruple et studios,  ",
      priceRange: "",
      nameHousing: "Qwetu et Qejani ",
      linkAdresPage: "/mksp/StudentHousingAdress",
      pros: [
        "Wi-Fi ",
        " 	Espaces détude dédiés",
        "Salles de sport",
        " 	Espaces de détente et de loisirs",
        " 	Sécurité 24h/24",
      ],
      cons: ["Espaces partagés", "Règles strictes"],
      recommendation:
        " Résidences étudiants haut de gamme offrant un cadre de vie confortable et sécurisé. ",
      weblink: "",
    },
    {
      description:
        "chambres : simples, individuelles, doubles, triple, quadruple et studios   ",
      priceRange: "",
      nameHousing: "Homescope Hostels ",
      linkAdresPage: "/mksp/StudentHousingAdress",
      pros: [
        " 	Générateur de secours",
        " Sécurité 24h/24",
        " 	Salles détude",
        " 	Cafétéria",
        "  	Su Pérette",
        " 	Service de blanchisserie",
        " 	Salle de prière",
        " 	Transports organisés",
      ],
      cons: ["Espaces partagés", "Règles strictes"],
      recommendation:
        "Résidences étudiants offrant un cadre de vie confortable, sécurisé et propice à la réussite académique.(meublées)",
    },
    {
      description:
        "chambres simple ou partagée(standard) chambre simple ou partagée(deluxe) studio(premier)",
      priceRange: "",
      nameHousing: "Mosaic Coliving  ",
      linkAdresPage: "/mksp/StudentHousingAdress",
      pros: [
        "  	Wi-Fi haut débit",
        " Sécurité 24h/24",
        " 	 	Électricité et eau incluses",
        "  	Cuisine équipée",
        " 	Espaces communs ",
        "  	Service de blanchisserie",
        "  	Nettoyage régulier des espaces communs",
      ],
      cons: ["Espaces partagés", "Règles strictes"],
      recommendation: "Idéal pour première année",
    },
    {
      description: "",
      priceRange: "",
      nameHousing: "Tsavo Lifestyle  ",
      linkAdresPage: "/mksp/StudentHousingAdress",
      pros: ["Appartement vide qui doit être meublée"],
      cons: ["Règles strictes"],
      recommendation:
        "Entreprise immobilière basée à Nairobi, spécialisée dans la création dappartements, Tsavo propose plusieurs résidences à Nairobi, notamment :   embakisi   ngong road  centre ville ",
    },
  ];

  // const universityCriteria = [
  //   {
  //     factor: "Accréditation",
  //     importance: "Critique",
  //     description:
  //       "Vérifier la reconnaissance officielle par le gouvernement kenyan",
  //     icon: <CheckCircle className="h-5 w-5 text-green-600" />,
  //   },
  //   {
  //     factor: "Programmes offerts",
  //     importance: "Élevée",
  //     description:
  //       "Correspondance avec vos objectifs académiques et professionnels",
  //     icon: <BookOpen className="h-5 w-5 text-blue-600" />,
  //   },
  //   {
  //     factor: "Réputation",
  //     importance: "Élevée",
  //     description:
  //       "Classements nationaux et internationaux, avis d'anciens étudiants",
  //     icon: <Star className="h-5 w-5 text-yellow-600" />,
  //   },
  //   {
  //     factor: "Coûts",
  //     importance: "Élevée",
  //     description: "Frais de scolarité, coût de la vie, bourses disponibles",
  //     icon: <DollarSign className="h-5 w-5 text-green-600" />,
  //   },
  //   {
  //     factor: "Localisation",
  //     importance: "Moyenne",
  //     description: "Proximité des commodités, sécurité du quartier, transport",
  //     icon: <MapPin className="h-5 w-5 text-red-600" />,
  //   },
  //   {
  //     factor: "Infrastructures",
  //     importance: "Moyenne",
  //     description: "Bibliothèques, laboratoires, équipements sportifs, WiFi",
  //     icon: <Wifi className="h-5 w-5 text-purple-600" />,
  //   },
  // ];

  const importantRecommendations = [
    {
      category: "Avant le départ",
      icon: <Clock className="h-6 w-6 text-blue-600" />,
      items: [
        "contactez le service de l'aéroport de votre pays ou les services d'immigration pour vérifier que tous vos documents sont en règle. Cela vous évitera tout désagrément à l'embarquement.",
      ],
    },
  ];

  const emergencyContacts = [
    // { service: "Police", number: "+", description: "Urgences policières" },
    // { service: "Ambulance", number: "999", description: "Urgences médicales" },
    // { service: "Pompiers", number: "999", description: "Incendies et sauvetages" },
    // { service: "Immigration", number: "+254 20 222 2022", description: "Questions de visa" },
    // { service: "Ambassade France", number: "+254 20 277 8000", description: "Citoyens français" },
  ];

  const sections = [
    {
      id: "visa",
      name: "Visa & Documents",
      icon: <FileText className="h-5 w-5" />,
    },
    {
      id: "RegistProcedure",
      name: "Procédure d'inscription",
      icon: <FileText className="h-5 w-5" />,
    },
    { id: "housing", name: "Logements", icon: <Home className="h-5 w-5" /> },
    {
      id: "universities",
      name: "Choix Universités",
      icon: <GraduationCap className="h-5 w-5" />,
    },
    {
      id: "recommendations",
      name: "Recommandations",
      icon: <AlertTriangle className="h-5 w-5" />,
    },
    {
      id: "downloandSuppor",
      name: "Download Support pdf",
      icon: <Download className="h-4 w-4 mr-2" />,
    },
  ];

  return (
    <div className="min-h-screen  mtCGfreeUniv dark:bg-gray-900  from-indigo-50 to-purple-50">
      {/* Header */}
      <header className="bg-white dark:bg-gray-900 shadow-sm ">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
          <BookOpen className="h-8 w-8 text-indigo-600" />
          <div className="flex items-center justify-between">
            <div className="flex items-center space-x-3">
              <div>
                <h1 className="text-2xl font-bold  dark:text-gray-200  text-gray-900">
                  Guide Étudiant
                </h1>
                <p className="text-gray-600 dark:text-gray-500 mt-1">
                  Pour un séjour, une expérience une vie agréable
                </p>
              </div>
            </div>
          </div>
        </div>
      </header>

      {/* Navigation */}
      <nav className="bg-white  sticky dark:bg-gray-900 top-0 z-10">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex space-x-8 overflow-x-auto">
            {sections.map((section) => (
              <button
                key={section.id}
                onClick={() => setActiveSection(section.id)}
                className={`flex items-center space-x-2 py-4 px-1 text-sm border-b-2 font-medium  dark:text-gray-300 whitespace-nowrap ${
                  activeSection === section.id
                    ? "border-indigo-500 text-indigo-600"
                    : "border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300"
                }`}
              >
                {section.icon}
                <span>{section.name}</span>
              </button>
            ))}
          </div>
        </div>
      </nav>

      <div className="max-w-7xl mx-auto px-1 sm:px-6 lg:px-8 mb-10 py-8">
        {/* Section Visa & Documents */}
        {activeSection === "visa" && (
          <div className="space-y-8">
            {/* Processus de visa */}
            {/* <Card className="p-6 dark:border-gray- text-center items-center dark:bg-[url(https://img2.wallspic.com/crops/1/2/2/0/6/160221/160221-whatsapp-blue-green-la_purete_de_la_couleur-turquoise-1080x1920.jpg)] ... bg-cover bg-center dark:bg-gray-800">
              <h3 className="text-xl dark:text-gray-300 font-semibold mb-4 flex items-center">
                <Clock className="h-5 w-5 mr-2  text-blue-600" />
                Processus de demande de visa
              </h3>
              <div className="">
                <div className="text-center">
                  <div className="bg-blue-100 rounded-full w-12 h-12 flex items-center justify-center mx-auto mb-2">
                    <span className="text-blue-600 font-bold">1</span>
                  </div>
                  <h4 className="font-medium">Préparation</h4>
                  <p className="text-sm dark:text-gray-400 text-gray-600">Rassembler tous les documents</p>
                </div>



              </div>
            </Card> */}

            {/* Documents requis */}
            <div>
              <h3 className="text-xl font-semibold mb-6">Documents requis</h3>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                {visaDocuments.map((doc, index) => (
                  <Card
                    key={index}
                    className="p-4 dark:bg-gray-800 dark:border-gray-800"
                  >
                    <div className="flex items-start justify-between">
                      <div className="flex-1">
                        <div className="flex items-center space-x-2 mb-2">
                          <h4 className="font-medium dark:text-blue-500">
                            {doc.name}
                          </h4>
                          {doc.required ? (
                            <Badge variant="danger">Obligatoire</Badge>
                          ) : (
                            <Badge variant="secondary">Optionnel</Badge>
                          )}
                        </div>
                        <p className="text-sm  dark:text-gray-400 text-gray-600 mb-2">
                          {doc.description}
                        </p>
                        <p className="text-sm  dark:text-gray-400 text-gray-600 mb-2">
                          {doc.description2}
                        </p>
                        <div className="flex items-center text-xs dark:text-gray-400 text-gray-500">
                          <Clock className="h-3 w-3 mr-1" />
                          {doc.processing}
                        </div>
                      </div>
                      {doc.required && (
                        <CheckCircle className="h-5 w-5 text-green-600 mt-1" />
                      )}
                    </div>
                  </Card>
                ))}
              </div>
            </div>

            {/* Coûts */}
            <Card className="p-6 dark:bg-gray-800 dark:border-gray-800">
              <h3 className="text-xl font-semibold mb-4">Coûts du visa</h3>
              <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                <div className="text-center p-4 dark:bg-gray-700 dark:border-gray-800 bg-blue-50 rounded-lg">
                  <DollarSign className="h-8 w-8 text-blue-600 mx-auto mb-2" />
                  <div className="text-2xl font-bold text-blue-600">USD 50</div>
                  <div className="text-sm dark:text-gray-400 text-gray-600">
                    Visa de régularisation 1-2 jours
                  </div>
                </div>
                <div className="text-center p-4 dark:bg-gray-700 dark:border-gray-800 bg-green-50 rounded-lg">
                  <DollarSign className="h-8 w-8 text-green-600 mx-auto mb-2" />
                  <div className="text-2xl font-bold text-green-600">
                    USD 100
                  </div>
                  <div className="text-sm dark:text-gray-400 text-gray-600">
                    Visa étudiant annuel 2-4 mois
                  </div>
                </div>
                <div className="text-center p-4 dark:bg-gray-700 dark:border-gray-800 bg-purple-50 rounded-lg">
                  <Clock className="h-8 w-8 text-purple-600 mx-auto mb-2" />
                  <div className="text-2xl font-bold text-purple-600">
                    2-4/mois
                  </div>
                  <div className="text-sm dark:text-gray-400 text-gray-600">
                    Traitement
                  </div>
                </div>
              </div>
            </Card>
          </div>
        )}

        {/* Section Logements */}
        {activeSection === "housing" && (
          <div className="space-y-8">
            <div className="text-center">
              <h2 className="text-1xl font-bold dark:text-blue-500 text-door mb-4">
                Logements Étudiants & Indemnités
              </h2>
              <p className=" dark:text-gray-400 text-gray-600 max-w-3xl mx-auto">
                Trouvez le logement étudiant idéal à Nairobi dans les meilleures
                quartiers de la capitale
              </p>
            </div>

            {/* Options de logement */}
            <>
              <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
                {housingOptions.map((option, index) => (
                  <Card
                    key={index}
                    className="p-6 dark:bg-gray-800 dark:border-gray-700  "
                  >
                    <div>
                      <span className=" text-2xl font-bold text-door dark:text-blue-500 text-door">
                        {option.nameHousing}
                      </span>
                    </div>
                    <div className="flex  items-center justify-between mb-4">
                      <h3 className=" dark:text-gray-300  font-semibold">
                        {option.description}
                      </h3>
                      <Badge variant="default">{option.priceRange}</Badge>
                    </div>
                    <div className="space-y-3">
                      <div>
                        <span className="text-sm font-medium text-green-700">
                          Avantages:{" "}
                        </span>
                        <div className="flex flex-wrap gap-1 mt-1">
                          {option.pros.map((pro, i) => (
                            <Badge
                              key={i}
                              variant="success"
                              className="text-xs "
                            >
                              {pro}
                            </Badge>
                          ))}
                        </div>
                      </div>

                      <div>
                        <span className="text-sm font-medium text-red-700">
                          Inconvénients:{" "}
                        </span>
                        <div className="flex flex-wrap gap-1 mt-1">
                          {option.cons.map((con, i) => (
                            <Badge
                              key={i}
                              variant="warning"
                              className="text-xs"
                            >
                              {con}
                            </Badge>
                          ))}
                        </div>
                      </div>
                      <div className="pt-2 ">
                        {/* <span className="text-sm font-medium text-blue-700">Recommandation: </span> */}
                        <span className="text-sm font-medium text-gray-400">
                          {option.recommendation}
                        </span>
                      </div>
                    </div>
                    <div className="flex  items-center justify-between mb-4">
                        
                      <div className="p-3">
                        {/* <a href={option.weblink} >
                          <Globe className="h-4 w-4 mr-1" />
                        </a> */}
                      </div>
                    </div>
                  </Card>
                ))}
              </div>
              <StudentHousing />
            </>
            <Card className="p-6  dark:bg-gray-800   dark:border-gray-700">
              <h3 className=" mb-4 dark:text-gray-300 dark:bg-gray-800  flex items-center">
                Parmi ces quartiers, on retrouve notamment Parklands, South B,
                South C, Kilimani, Roysambu, Thome, Mbagathi et Lang'ata. Et
                aussi Westland, Ruaka, Kileleshwa, qui regorge aussi des studios
                à votre choix sont reconnus pour : ' Une présence policière ou
                privée constante assurant la tranquillité des résident.e.s,
              </h3>
            </Card>
            <div className="grid grid-cols-1 mt-10 lg:grid-cols-2 gap-6">
              {infoSupLoge.map((option, index) => (
                <Card
                  key={index}
                  className="p-6 rounded-lg dark:bg-gray-800  dark:border-gray-700"
                >
                  <div className="flex items-center  space-x-3 mb-4">
                    <h3 className=" font-semibold">{option.title}</h3>
                  </div>
                  <ul className="space-y-3">
                    <li className="flex items-start space-x-2">
                      <CheckCircle className="h-4 w-4 text-green-600 mt-0.5 flex-shrink-0" />
                      <span className="text-sm dark:text-gray-300 text-gray-700">
                        {option.description}
                      </span>
                    </li>
                  </ul>
                </Card>
              ))}
            </div>

            <Card className="p-6 dark:bg-gray-800 mt-5  dark:border-gray-700">
              <h3 className=" mb-4 flex items-center">
                Ce choix de localisation n'est pas un hasard : il vise à
                favoriser l'intégration, la sécurité et le confort dès leur
                arrivée à Nairobi.
              </h3>
            </Card>

            {/* Système d'indemnités */}
            <Card className="p-6 dark:bg-gray-800 dark:border-gray-700 ">
              <h3 className="text-xl font-semibold dark:text-gray-400 mb-4">
                Système d'indemnités et cautions
              </h3>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                <div>
                  <h4 className="font-medium mb-3 text-green-700">
                    Ce qui est remboursable
                  </h4>
                  <ul className="space-y-2 text-sm">
                    <li className="flex items-center">
                      <CheckCircle className="h-4 w-4 text-green-600 mr-2" />
                      Caution de sécurité (si pas de dégâts)
                    </li>
                    <li className="flex items-center">
                      <CheckCircle className="h-4 w-4 text-green-600 mr-2" />
                      Dépôt de garantie (conditions respectées)
                    </li>
                    <li className="flex items-center">
                      <CheckCircle className="h-4 w-4 text-green-600 mr-2" />
                      Avance sur charges (si non utilisée)
                    </li>
                  </ul>
                </div>
                <div>
                  <h4 className="font-medium mb-3 text-red-700">
                    Frais non remboursables
                  </h4>
                  <ul className="space-y-2 text-sm">
                    <li className="flex items-center">
                      <AlertTriangle className="h-4 w-4 text-red-600 mr-2" />
                      Frais d'agence (10% du loyer annuel)
                    </li>
                    <li className="flex items-center">
                      <AlertTriangle className="h-4 w-4 text-red-600 mr-2" />
                      Frais de dossier
                    </li>
                    <li className="flex items-center">
                      <AlertTriangle className="h-4 w-4 text-red-600 mr-2" />
                      Premier mois de loyer
                    </li>
                  </ul>
                </div>
              </div>
            </Card>
          </div>
        )}

        {/* Section Choix des universités */}
        {activeSection === "universities" && (
          <div className="-mt-20 ">
            <GdFree />
          </div>
        )}

        {/* RegistProcedure */}
        {activeSection === "RegistProcedure" && (
          <div className="-mt-20 ">
            <RegistProcedure />
          </div>
        )}

        {/* Section Recommandations */}
        {activeSection === "recommendations" && (
          <div className="space-y-8">
            <div className="text-center">
              <h2 className="text-2xl dark:text-blue-500 font-bold text-gray-900 mb-4">
                Recommandations Importantes
              </h2>
              <p className="text-lg dark:text-gray-400 text-gray-600 max-w-3xl mx-auto">
                Conseils essentiels pour réussir votre séjour d'études au Kenya
                en toute sécurité.
              </p>
            </div>

            {/* Recommandations par catégorie */}
            {/* grid grid-cols-1 lg:grid-cols-2 gap-6 */}
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
              {importantRecommendations.map((category, index) => (
                <Card
                  key={index}
                  className="p-6 dark:bg-gray-800  dark:border-gray-700"
                >
                  <div className="flex items-center  space-x-3 mb-4">
                    {category.icon}
                    <h3 className="text-lg font-semibold">
                      {category.category}
                    </h3>
                  </div>
                  <ul className="space-y-3">
                    {category.items.map((item, i) => (
                      <li key={i} className="flex items-start space-x-2">
                        <CheckCircle className="h-4 w-4 text-green-600 mt-0.5 flex-shrink-0" />
                        <span className="text-sm dark:text-gray-300 text-gray-700">
                          {item}
                        </span>
                      </li>
                    ))}
                  </ul>
                </Card>
              ))}
            </div>

            {/* Contacts d'urgence */}
            <Card className="p-6 dark:bg-gray-800  dark:border-gray-700">
              <h3 className="text-xl font-semibold mb-4 flex items-center">
                <Phone className="h-5 w-5 mr-2 text-red-600" />
                Contacts d'urgence
              </h3>
              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
                {emergencyContacts.map((contact, index) => (
                  <div
                    key={index}
                    className="bg-red-50 dark:bg-gray-700  dark:border-gray-300 rounded-lg p-4"
                  >
                    <div className="font-medium text-xl dark:text-red-400 text-red-900">
                      {contact.service}
                    </div>
                    <div className="text-lg font-bold dark:text-red-300 text-red-500">
                      {contact.number}
                    </div>
                    <div className="text-sm dark:text-red-300 text-red-600">
                      {contact.description}
                    </div>
                  </div>
                ))}
              </div>
            </Card>

            {/* Ressources utiles */}
          </div>
        )}

        {/* Section downloandSuppor */}
        {activeSection === "downloandSuppor" && (
          <>
            <RecentUploads />
          </>
        )}
      </div>

      {/* Footer */}
    </div>
  );
}

export default RgByNord;
